import React, { useContext, useState } from "react";
import formatNumber from "../../../utils/formatNumber";
// style
import Style from "./NewEmploymentPositions.module.css";

// my components
import Position from "./Position/Position";

// context
import { FirstInputFormDataContext } from "../../../context/FirstInputFormDataContext";
import { SecondInputFormDataContext } from "../../../context/SecondInputFormDataContext";

const NewEmploymentPositions = ({ formType }) => {
  const { newEmploymentPositions, setNewEmploymentPositions } = useContext(
    formType === "first"
      ? FirstInputFormDataContext
      : SecondInputFormDataContext
  );
  const [employmentPosition, setEmploymentPosition] = useState({
    positionName: "",
    positionSalary: "",
    positionPercentage: "",
    expectedWorkTimeDurationInMonths: "",
  });

  let percentageSign = "%";

  // function that reformats number from 1,000 to 1000
  const reFormatNumber = (value) => {
    const numericValue = value.replace(/[^\d.]/g, "");
    return numericValue;
  };

  const handleNameChange = (e) => {
    setEmploymentPosition({
      ...employmentPosition,
      positionName: e.target.value,
    });
  };

  const handleBruttoSalaryChange = (e) => {
    setEmploymentPosition({
      ...employmentPosition,
      positionSalary: formatNumber(e.target.value),
    });
  };

  const handleTimePercentageChange = (e) => {
    const value = e.target.value;

    if ((value === "" || (value >= 0 && value <= 100)) && value.length <= 3) {
      setEmploymentPosition({
        ...employmentPosition,
        positionPercentage: value,
      });
    }
  };

  const handleWorkTimeDurationChange = (e) => {
    setEmploymentPosition({
      ...employmentPosition,
      expectedWorkTimeDurationInMonths: formatNumber(e.target.value),
    });
  };

  const addNewPosition = () => {
    if (
      employmentPosition.positionName === "" ||
      employmentPosition.positionSalary === "" ||
      employmentPosition.positionPercentage === "" ||
      employmentPosition.expectedWorkTimeDurationInMonths === ""
    ) {
      alert("Niste unijeli sve podatke");
    } else {
      setNewEmploymentPositions([
        ...newEmploymentPositions,
        {
          positionName: employmentPosition.positionName,
          positionSalary: reFormatNumber(employmentPosition.positionSalary),
          positionPercentage: employmentPosition.positionPercentage,
          expectedWorkTimeDurationInMonths: reFormatNumber(
            employmentPosition.expectedWorkTimeDurationInMonths
          ),
        },
      ]);

      setEmploymentPosition({
        positionName: "",
        positionSalary: "",
        positionPercentage: "",
        expectedWorkTimeDurationInMonths: "",
      });
    }
  };

  return (
    <div className={Style.PositionsContainer}>
      <div className={Style.InputContainer}>
        <div className={Style.InputTitle}>Naziv novog radnog mjesta</div>
        <div className={Style.ValueInputContainer}>
          <input
            className={Style.ValueInput}
            onChange={handleNameChange}
            value={employmentPosition.positionName}
            type="text"
            placeholder="molimo popunite polje..."
          ></input>
        </div>
        <div className={Style.InputTitle}>
          Vrijeme trajanja rada na projektu u mjesecima
        </div>
        <div className={Style.ValueInputContainer}>
          <input
            className={Style.ValueInput}
            onChange={handleWorkTimeDurationChange}
            value={employmentPosition.expectedWorkTimeDurationInMonths}
            type="text"
            placeholder="molimo popunite polje..."
          ></input>
          mj.
        </div>
        <div className={Style.InputTitle}>Bruto 2 plaća</div>
        <div className={Style.ValueInputContainer}>
          <input
            className={Style.ValueInput}
            onChange={handleBruttoSalaryChange}
            value={employmentPosition.positionSalary}
            type="text"
            placeholder="molimo popunite polje..."
          ></input>
          EUR
        </div>
        <div className={Style.InputTitle}>Postotak radnog vremena</div>
        <div className={Style.ValueInputContainer}>
          <input
            className={Style.ValueInput}
            type="number"
            onChange={handleTimePercentageChange}
            value={employmentPosition.positionPercentage}
            placeholder="molimo popunite polje..."
            min="0"
            max="100"
          ></input>
          {percentageSign}
        </div>
        <button
          onClick={() => addNewPosition()}
          className={Style.AddNewPositionButton}
        >
          DODAJ NOVO RADNO MJESTO
        </button>
      </div>
      <div style={{ fontWeight: "700", color: "var(--question-title-color)" }}>
        DODANA RADNA MJESTA:
      </div>
      {newEmploymentPositions?.length > 0 ? (
        newEmploymentPositions.map((position, index) => {
          return (
            <Position
              key={index}
              positionProp={position}
              setNewPositionsProp={setNewEmploymentPositions}
              formatNumber={formatNumber}
            />
          );
        })
      ) : (
        <div style={{ fontSize: "1em" }}>
          Ni jedno radno mjesto nije dodano...
        </div>
      )}
    </div>
  );
};

export default NewEmploymentPositions;
